import { getCurrency, nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { getFileLinkFromString } from './FileAccessUtils';
import { ROLE_TYPES } from './DataConstants';

// Suppliers bill in their own facility's currency; buyers bill in their company's, which
// getCurrency resolves off currentUser.facility.buyerCompany. This is the *viewer's* currency —
// only a fallback for a record that has none of its own, never a reason to reformat a stored
// amount.
export const getSpotPurchaseDisplayCurrencyId = (userType: string, currentUser: any) =>
	userType === ROLE_TYPES.SUPPLIER
		? nullSafeGetOrElse('facility.currencyId', currentUser, 'USD')
		: nullSafeGetOrElse('id', getCurrency({ currentUser }), 'USD');

// A receipt is stored either as an absolute URL or as the "<fileId>/<fileName>" pair the
// protected file-download endpoint takes.
export const getSpotPurchaseReceiptUrl = (userType: string, record: any) => {
	const receiptUrl = nullSafeGet('receiptUrl', record);
	if (!receiptUrl) return null;
	return /^https?:\/\//i.test(receiptUrl)
		? receiptUrl
		: getFileLinkFromString(userType)(receiptUrl);
};

// RecordSpotPurchaseModal snapshots the recording user's currency onto each record, and both
// roles can add purchases to the same work order, so one work order's records can legitimately
// carry different currencies. Adding those together would produce a number denominated in
// nothing, so the aggregate is only offered when every record agrees; callers hide the total
// entirely when this returns null.
export const getSpotPurchaseAggregate = (records: any[], fallbackCurrencyId: any) => {
	if (!records || records.length === 0) return null;
	const currencyIds = records.map((record) =>
		nullSafeGetOrElse('currencyId', record, fallbackCurrencyId)
	);
	if (currencyIds.some((currencyId) => currencyId !== currencyIds[0])) return null;
	return {
		currencyId: currencyIds[0],
		totalCost: records.reduce(
			(runningTotal: number, record: any) =>
				runningTotal + (Number(nullSafeGet('totalCost', record)) || 0),
			0
		),
	};
};
